export const OUTLOOK365 = 'o365';
export const OUTLOOK_MAC = 'outlook-mac';
export const MICROSOFT = 'MICROSOFT';
export const GOOGLE = 'GOOGLE';
export const APPLE = 'APPLE';
export const SSO = 'SSO';
export const UNKNOWN = 'UNKNOWN';
export const HUBSPOT = 'HUBSPOT';
export const HUBSPOT_MAC_OUTLOOK = 'HUBSPOT_MAC_OUTLOOK';
export const HUBSPOT_DESKTOP_OUTLOOK = 'HUBSPOT_DESKTOP_OUTLOOK';
export const PASSKEY = 'PASSKEY';
export const OPEN_AI = 'OPEN_AI';
export const OTP = 'OTP';
export const CHROME_EXTENSION = 'crx';